/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import _ from 'lodash';

import { Portal } from '../../../../ts/portal';
import { PortalsSlice } from '../../../../ts/state';
import { SET_ASSISTANT_ID } from '../session/actionTypes';

const initialState: PortalsSlice = {
  stack: []
};

/**
 * Gets the initial state of the redux slice and apply updates.
 * @param {*} updates The updates to apply to the initial state
 * @returns {*} The slice initial state
 */
export const computeState = (updates?: any): PortalsSlice => ({
  ..._.cloneDeep(initialState),
  ...updates
});

const slice = createSlice({
  name: 'portals',
  initialState: computeState(),
  reducers: {
    pushPortal(state, action: PayloadAction<Portal>) {
      const portal = action.payload;
      state.stack.push(portal);
    },

    popPortal(state) {
      state.stack.pop();
    },

    resetPortals(state) {
      state.stack = [];
    }
  },
  extraReducers: {
    [SET_ASSISTANT_ID]: state => {
      state.stack = [];
    }
  }
});

export const { pushPortal, popPortal, resetPortals } = slice.actions;
export default slice.reducer;
